// extracted by mini-css-extract-plugin
export default {"startButton":"Header_startButton__zL8BD"};